import { Link } from "react-router-dom";
import {
  HeadingTitle,
  SubHeadingTitle,
  Button,
  Image,
} from "../../../components/shared/index";
import styles from "./aboutus.module.css";
const Store = () => {
  return (
    <>
      <section className={styles.store__wrapper}>
        <div className={styles.textContent}>
          <HeadingTitle
            text={
              <>
                <span className={styles.highlight}> Welcome to Vitaura Life Sciences </span>
                <br />
              </>
            }
            style={styles.heading}
          />

          <SubHeadingTitle
            subTitle={
              <p>
               At VITAURA, we are committed to providing high-quality healthcare products and trusted pharmaceutical services to support the well-being of our community. Our mission is to make healthcare accessible, affordable, and convenient by offering a wide range of medicines, wellness products, skincare essentials, and health supplements from reliable brands. With a customer-first approach, we focus on delivering exceptional service, genuine products, and expert guidance to help our customers make informed health decisions .
              </p>
            }
          />

          {/* ✅ Move button here */}
          <Link to={"/shop"}>
            <Button
              type="button"
              title={"Shop Now"}
              style={styles.shopBtn}
            />
          </Link>
        </div>

        <div className={styles.imageWrapper}>
          <Image
            src="/assets/img/backgrounds/aboutside-imge.png"
            className={styles.image}
            alt="Hiraola Jewellery"
          />
        </div>
      </section>
    </>
  );
};
export default Store; 
